import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";

export default function DotGroup({ selectedPage, SetselectedPage }) {
  const CustomStyle = `relative bg-red before:absolute before:w-6 before:h-6
    before:rounded-full before:border-2 before:border-red before:left-[-50%]
    before:top-[-50%]
    `;
  return (
    <div className="flex flex-col gap-6 fixed top-[50%] right-7">
      <AnchorLink
        className={`${selectedPage === "home" ? CustomStyle : "bg-dark-grey"}
        w-3 h-3 rounded-full`}
        href={`#home`}
        onClick={() => SetselectedPage("home")}
      />
      <AnchorLink
        className={`${selectedPage === "skills" ? CustomStyle : "bg-dark-grey"}
        w-3 h-3 rounded-full`}
        href={`#skills`}
        onClick={() => SetselectedPage("skills")}
      />
      <AnchorLink
        className={`${
          selectedPage === "projects" ? CustomStyle : "bg-dark-grey"
        }
        w-3 h-3 rounded-full`}
        href={`#projects`}
        onClick={() => SetselectedPage("projects")}
      />
      <AnchorLink
        className={`${
          selectedPage === "certificate" ? CustomStyle : "bg-dark-grey"
        }
        w-3 h-3 rounded-full`}
        href={`#certificate`}
        onClick={() => SetselectedPage("certificate")}
      />
      <AnchorLink
        className={`${selectedPage === "contact" ? CustomStyle : "bg-dark-grey"}
        w-3 h-3 rounded-full`}
        href={`#contact`}
        onClick={() => SetselectedPage("contact")}
      />
    </div>
  );
}
